export default {
  VND: 1,
  Dola: 2,
};
